"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.privateRouter = exports.publicRouter = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const schemas_1 = require("../schemas");
const pathPrefix = '/rundowns';
const c = (0, core_1.initContract)();
const getCompiledInk = c.router({
    getCompiledInk: {
        method: 'GET',
        path: '/:id/inkjson',
        pathParams: zod_1.z.object({
            id: schemas_1.IntegerPathParam,
        }),
        responses: {
            200: schemas_1.InkCompileResult,
        },
        summary: 'Compile all ink sources included in the rundown',
    },
});
const getDetails = c.router({
    getDetails: {
        method: 'GET',
        path: '/:id/details',
        pathParams: zod_1.z.object({
            id: schemas_1.IntegerPathParam,
        }),
        responses: {
            200: schemas_1.RundownDetail,
        },
    },
});
exports.publicRouter = c.router(Object.assign({}, getCompiledInk), { pathPrefix });
exports.privateRouter = c.router(Object.assign(Object.assign({}, getDetails), getCompiledInk), { pathPrefix });
